import { ContentCardProps, ContentType } from "../components/ContentCard/contentCardTypes";
import { Level } from "../contexts/Level/LevelContextProvider";
import { levelToVariant } from "./colorUtils";

const LEVEL_NAME_REPLACE = "%{default_level_name}";
const LEVEL_DESC_REPLACE = "%{default_level_description}";

const LESSON_TYPE_MAP: Record<string, ContentType> = {
  VideoLesson: "video",
  VideoWithCodingExercise: "video",
  CodingChallenge: "codingChallenge",
  CtfChallenge: "ctfChallenge",
  CodingExerciseItem: "exercise",
  HandsOnLesson: "breakfix",
  HackingChallenge: "hackingChallenge",
  AppLab: "app_lab",
  LESSON_CONFIGURATION_TYPE_UNSPECIFIED: "video",
};

export function replaceSubstringIfExists(
  originalString: string,
  searchSubstring: string,
  replacement: string
): string {
  if (originalString.includes(searchSubstring)) {
    return originalString.replace(searchSubstring, replacement);
  }
  return originalString;
}

export const mapCollectionToCard = (collection: any, levelsDetails?: Level[]): ContentCardProps => {
  const associatedLevel = levelsDetails?.find(level => level.id === collection.levelId);
  const name = replaceSubstringIfExists(
    collection.name,
    LEVEL_NAME_REPLACE,
    associatedLevel?.name || "Level"
  );

  return {
    contentType: "path",
    id: (collection.collectionKey as string) || "",
    lessonType: "path",
    name: name,
    title: name,
    description: replaceSubstringIfExists(
      collection.description || "",
      LEVEL_DESC_REPLACE,
      associatedLevel?.description || "Level description"
    ),
    difficulty: associatedLevel ? associatedLevel.name : undefined,
    cardSize: "small",
    variant: levelToVariant(collection.levelId),
    estimatedTimeToComplete: collection.combinedDuration,
    lessonsInEnrollment: collection.lessonCount || undefined,
  };
};

export const mapCollectionsToCards = (
  collections: any[],
  levelsDetails?: Level[]
): ContentCardProps[] => {
  return collections.map(collection => mapCollectionToCard(collection, levelsDetails));
};

export const mapLessonToCard = (lesson: any): ContentCardProps => {
  const contentType = LESSON_TYPE_MAP[lesson.type] || "video";

  return {
    contentType,
    lessonType: contentType,
    id: (lesson.lessonId as string) || "",
    lessonKey: lesson.lessonKey || "",
    title: lesson.name || "",
    description: lesson.description || "",
    estimatedTime: lesson.duration || undefined,
  };
};

export const mapLessonsToCards = (lessons: any[]): ContentCardProps[] => {
  return lessons.map(mapLessonToCard);
};
